{
    "EnablerptrequestauditLabel": "Abilita l'output di controllo della richiesta di report:",
    "Audit_SectionHeader": "Audit",
    "Audit_SectionPara": "Attenzione: Attivare la seguente impostazione solo se richiesto da un membro del team di amministrazione o di supporto dell'applicazione.",
    "NAME": "Audit"
}